import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-yu-rating',
  templateUrl: './yu-rating.component.html',
  styleUrls: ['./yu-rating.component.scss'],
  standalone: false
})
export class YuRatingComponent {

  @Input() max: number = 10;

  @Input() showNumber: boolean = true;
  @Input() readonly: boolean = false;
  @Input() smallSize: boolean = false;

  @Input() value: number | null = null;
  @Output() valueChange: EventEmitter<number> = new EventEmitter<number>();

  showScore: boolean = false;

  /**
   * Contador
   *
   */
  counter(max: number): number[] {
    return new Array(max);
  }


  /**
   * Asignar puntuación
   *
   */
  setScore(index: number) {

    if (this.readonly) {
      return;
    }

    this.value = index + 1;
    this.valueChange.emit(this.value);

    this.showScoreAction();
  }


  /**
   * Acción para mostrar la puntuación
   *
   */
  showScoreAction() {
    this.showScore = true;
    setTimeout(() => this.showScore = false, 600);
  }

}
